import { OAuthService } from 'angular-oauth2-oidc';
import { inject, Injectable } from '@angular/core';
import { UserInfo, getUserInfo } from '@pool-league/shared-util-auth';

/**
 * Provides details of the logged-in user, as per the active ID token.
 */
@Injectable({
  providedIn: 'root',
})
export class UserInfoService {
  readonly #authService = inject(OAuthService);

  getMe(): UserInfo {
    const claims = this.#authService.getIdentityClaims();
    return getUserInfo(claims);
  }

  getMeIfLoggedIn(): UserInfo | undefined {
    return this.#authService.hasValidIdToken() ? this.getMe() : undefined;
  }

  isMe(bbUserName: string | undefined): boolean {
    if (!bbUserName) {
      return false;
    }
    const claims = this.#authService.getIdentityClaims() || {};
    return (
      bbUserName ===
      (typeof claims.email === 'string'
        ? claims.email.split('@')[0]
        : claims['cognito:username'])
    );
  }
}
